import { Flex } from '@radix-ui/themes';
import { ConnectedCollectionAvenue } from './avenues/ConnectedCollectionAvenue';
import { AVENUE_TITLES, useAvenueConfigs } from './hooks/useAvenueConfigs';
import { MetricsSection } from './dashboard';

export const HomeUI = () => {
    const { configs, isReady } = useAvenueConfigs();

    return (
        <Flex direction={'column'} gap={'8'} mt={'4'} flexGrow={'1'}>
            <MetricsSection />

            {isReady &&
                AVENUE_TITLES.map((title) => (
                    <ConnectedCollectionAvenue
                        key={title}
                        configMap={configs}
                        title={title}
                    />
                ))}
        </Flex>
    );
};
